import React, { Component } from "react";
import EditAdminDialog from "../../components/admins/EditAdminDialog";
import CreateIcon from "@material-ui/icons/Create";
import IconButton from "@material-ui/core/IconButton";
import { languages } from "../../constants/languages";
import Button from "@material-ui/core/Button";

class EditAdminContainer extends Component {
  state = {
    open: false,
    name: "",
    submitDisabled: true,
    searchingUser: false,
    errorMessage: "",
    manageGeneral: false,
    manageTeams: false,
    manageFormat: false,
    manageSchedule: false,
    managePresentation: false,
    managePublicWebsite: true,
    manageSlideshow: true,
    manageDesign: true,
    manageResults: false,
    managePhases: true,
  };

  toggleDialog = () => {
    this.setState({ open: !this.state.open });
  };

  UNSAFE_componentWillMount = () => {
    const admin = this.props.admin;
    if (admin) {
      this.updateState(admin);
    }
  };

  updateState = (admin) => {
    this.setState({
      name: admin.name || "",
      manageGeneral: admin.manageGeneral || false,
      manageTeams: admin.manageTeams || false,
      manageFormat: admin.manageFormat || false,
      manageSchedule: admin.manageSchedule || false,
      managePresentation: admin.managePresentation || false,
      managePublicWebsite:
        admin.managePublicWebsite === true ||
        admin.managePublicWebsite === undefined
          ? true
          : false,
      manageSlideshow:
        admin.manageSlideshow === true || admin.manageSlideshow === undefined
          ? true
          : false,
      manageDesign:
        admin.manageDesign === true || admin.manageDesign === undefined
          ? true
          : false,
      manageResults: admin.manageResults || false,
      managePhases:
        admin.managePhases === true || admin.managePhases === undefined
          ? true
          : false,
    });
  };

  handleSwitch = (event, checked) => {
    let newState = { submitDisabled: false };
    newState[event.target.name] = checked;
    this.setState(newState);
  };

  handleChange = (event) => {
    let newState = {};
    newState[event.target.name] = event.target.value;
    if (event.target.name === "name") {
      if (event.target.value.length > 0) {
        newState["submitDisabled"] = false;
      } else {
        newState["submitDisabled"] = true;
      }
    } else if (this.props.admin) {
      newState["submitDisabled"] = false;
    }
    this.setState(newState);
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ submitDisabled: true, searchingUser: true });

    fetch(
      "https://us-central1-tournify-functions.cloudfunctions.net/getUidForEmail",
      {
        method: "POST",
        mode: "cors",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: { email: this.state.name },
        }),
      }
    )
      .then(function (response) {
        return response.json();
      })
      .then(
        function (data) {
          let uid = data.uid;
          if (uid !== undefined) {
            if (uid === this.props.tournament.uid) {
              this.setState({
                errorMessage: languages.admins.userIsYou,
                searchingUser: false,
              });
            } else {
              const tournamentRef = window.firebase
                .firestore()
                .collection("tournaments")
                .doc(this.props.tournament[".key"]);

              const adminsRef = tournamentRef.collection("admins");

              let admin = {};
              let adminDoc = adminsRef.doc(uid);
              if (this.props.admin) {
                admin = this.props.admin;
                adminDoc = adminsRef.doc(this.props.admin.id);
              }

              admin["name"] = this.state.name;
              admin["manageGeneral"] = this.state.manageGeneral;
              admin["manageTeams"] = this.state.manageTeams;
              admin["manageFormat"] = this.state.manageFormat;
              admin["manageSchedule"] = this.state.manageSchedule;
              admin["managePresentation"] = this.state.managePresentation;
              admin["managePublicWebsite"] = this.state.managePublicWebsite;
              admin["manageSlideshow"] = this.state.manageSlideshow;
              admin["manageDesign"] = this.state.manageDesign;
              admin["manageResults"] = this.state.manageResults;
              admin["managePhases"] = this.state.managePhases;

              let batch = window.firebase.firestore().batch();
              if (this.props.admin === undefined) {
                let admins = this.props.tournament.admins || [];
                admins.push(uid);
                batch.update(tournamentRef, { admins: admins });
              }
              batch.set(adminDoc, admin);
              batch
                .commit()
                .then(() => {
                  if (this.props.admin) {
                    this.setState({
                      submitDisabled: true,
                      searchingUser: false,
                      errorMessage: "",
                    });
                  } else {
                    this.setState({
                      submitDisabled: true,
                      name: "",
                      searchingUser: false,
                      errorMessage: "",
                    });
                  }
                  this.toggleDialog();
                })
                .catch((error) => {
                  this.setState({ submitDisabled: false });
                });
            }
          } else {
            this.setState({
              errorMessage: languages.login.userNotFound,
              searchingUser: false,
            });
          }
        }.bind(this)
      );
  };

  render() {
    return (
      <div>
        {this.props.admin ? (
          <IconButton
            aria-label="Change"
            onClick={this.toggleDialog}
            disabled={this.props.disabled}
            style={{ height: 30, width: 30 }}
          >
            <CreateIcon
              style={{ height: 20, width: 20, position: "absolute", top: 5 }}
            />
          </IconButton>
        ) : (
          <Button
            size="small"
            variant="outlined"
            color="default"
            onClick={this.toggleDialog}
          >
            {languages.admins.addAdmin}
          </Button>
        )}
        <EditAdminDialog
          name={this.state.name}
          submitDisabled={this.state.submitDisabled}
          open={this.state.open}
          admin={this.props.admin}
          toggleDialog={this.toggleDialog}
          handleChange={this.handleChange}
          handleSubmit={this.handleSubmit}
          errorMessage={this.state.errorMessage}
          searchingUser={this.state.searchingUser}
          handleSwitch={this.handleSwitch}
          manageGeneral={this.state.manageGeneral}
          manageTeams={this.state.manageTeams}
          manageFormat={this.state.manageFormat}
          manageSchedule={this.state.manageSchedule}
          managePresentation={this.state.managePresentation}
          managePublicWebsite={this.state.managePublicWebsite}
          manageSlideshow={this.state.manageSlideshow}
          manageDesign={this.state.manageDesign}
          manageResults={this.state.manageResults}
          managePhases={this.state.managePhases}
        />
      </div>
    );
  }
}

export default EditAdminContainer;
